module.exports = __webpack_public_path__ + "img/2.254b4f9c.png";